module.exports = __webpack_public_path__ + "static/flags/LA-df315292a8ff1b65676cdfaf8b3f969c.gif";